var ParallaxInit;

(function ($) {

	const selectors = {
		box: '[data-parallax]'
	}

	var winData = {
		height: $(window).height()
	}

	ParallaxInit = class ParallaxInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new Parallax(el);
			})
		}
	}

	class Parallax {
		constructor(element) {
			this.box = element;

			this.init();
			this.resize();
			this.bind();

			// console.log(this);

		}
		init() {
			this.speed = $(this.box).attr('data-speed') ? parseFloat($(this.box).attr('data-speed')) : 1.2;
			this.wrap = $(this.box).parent().get(0);

			this.direction = $(this.box).attr('data-direction') ? $(this.box).attr('data-direction').toLowerCase() : 'y';
			this.additionalScrollOffset = $(this.box).attr('data-scroll-offset') ? parseInt($(this.box).attr('data-scroll-offset')) : 0;
			this.from = $(this.box).attr('data-from') ? $(this.box).attr('data-from') : 'center';
			this.breakpoint = $(this.box).attr('data-from-breakpoint') ? $(this.box).attr('data-from-breakpoint') : false;

			$(this.wrap).addClass('parallax-wrap');


		}
		bind() {

			// const throttledScroll = throttle(30, false, () => {
			// 	this.scroll();
			// });

			$(document).ready((e) => { this.resize(); });
			$(window).resize((e) => { this.resize(); });
			// $(window).scroll( (e) => { throttledScroll(); } );
			$(window).scroll((e) => { this.scroll(); });

		}
		resize() {
			// $(this.box).width( this.width );
			// 
			this.wrapOffTop = $(this.wrap).offset().top;
			this.wrapHeight = $(this.wrap).outerHeight();
			winData.height = $(window).height();

			this.scroll();
		}

		scroll() {

			if (this.breakpoint && !Foundation.MediaQuery.atLeast(this.breakpoint)) {
				$(this.box).css('transform', '');
				return;
			}

			var scroll_off;

			if (this.from == "center") {
				scroll_off = $(window).scrollTop() - this.additionalScrollOffset - this.wrapOffTop + winData.height / 2 - this.wrapHeight / 2;
			}
			else if (this.from == "top") {
				scroll_off = $(window).scrollTop() - this.additionalScrollOffset - this.wrapOffTop;
			}

			var new_off = scroll_off * (1 - this.speed);


			// console.log(scroll_off);

			if (this.direction == 'y') {
				$(this.box).css('transform', 'translateY(' + new_off + 'px)');
			}
			else if (this.direction == 'x') {
				$(this.box).css('transform', 'translateX(' + new_off + 'px)');
			}


		}

	}

})(jQuery);


export default ParallaxInit;